<template>
  <v-container>
    <TitleParagraphRow :value="value" />

    <v-row v-if="value.items && value.items.length" align="center">
      <v-col>
        <v-row>
          <SideTextCol :value="value.side_text" />

          <v-col>
            <v-card
              class="d-flex ma-2"
              color="bg-surface"
              height="560"
              rounded="0"
            >
              <v-img
                :key="imgResp.src"
                :aspect-ratio="aspectRatio"
                :sizes="imgResp.sizes"
                :src="imgResp.src"
                :srcset="imgResp.srcset"
                alt="Photo for the case study"
                class="d-none d-lg-flex"
                cover
                max-width="600"
                width="560"
              >
                <template #placeholder>
                  <div class="d-flex align-center justify-center fill-height">
                    <v-progress-circular
                      :size="80"
                      color="red-darken-2"
                      indeterminate
                    ></v-progress-circular></div
                ></template>

                <v-img
                  v-if="highlight"
                  :src="hdCaseStudyHighlight"
                  alt="Highlight badge for the case study"
                  aspect-ratio="1"
                  class="ma-4"
                  width="170"
                />
              </v-img>

              <div>
                <v-window v-model="selectedItem" class="fill-height">
                  <v-window-item
                    v-for="item in value.items"
                    :key="item.id"
                    class="fill-height"
                  >
                    <div class="d-flex flex-column pa-8 pa-md-12 fill-height">
                      <CaseStudyContentBlock :value="item" />
                    </div>
                  </v-window-item>
                </v-window>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="value.items.length > 1">
          <v-col>
            <v-item-group v-model="selectedItem" class="text-center" mandatory>
              <v-item
                v-for="item in value.items"
                :key="item.id"
                v-slot="{ isSelected, toggle }"
              >
                <v-btn
                  :icon="mdiRecord"
                  :color="isSelected ? 'cyan' : undefined"
                  variant="text"
                  @click="toggle"
                />
              </v-item>
            </v-item-group>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { onMounted, ref, toRef } from 'vue'
import { useIntervalFn } from '@vueuse/core'
import { useImgResponsive } from '#root/lib/img'
// import { slugify } from '#root/lib/utils'
import { mdiRecord } from '@mdi/js'
import hdCaseStudyHighlight from '#root/assets/logos/hd-case-study-highlight.svg'

const UPDATE_INTERVAL = 12 * 1000 // 12s

const props = defineProps({
  highlight: {
    default: false,
    type: Boolean
  },
  value: {
    required: true,
    type: Object
  }
})

const selectedItem = ref(null)
const aspectRatio = 1
const imgResp = useImgResponsive(
  toRef(() => ({
    aspectRatio,
    image:
      props.value.items[selectedItem.value] &&
      props.value.items[selectedItem.value].image_choice === 'Testimonial' &&
      props.value.items[selectedItem.value].testimonial &&
      props.value.items[selectedItem.value].testimonial.image
        ? props.value.items[selectedItem.value].testimonial.image
        : props.value.items[selectedItem.value] &&
            props.value.items[selectedItem.value].image
          ? props.value.items[selectedItem.value].image
          : undefined,
    sizes: {
      lg: '1200px'
    }
  }))
)

function selectNext() {
  selectedItem.value =
    selectedItem.value < props.value.items.length - 1
      ? selectedItem.value + 1
      : 0
}

useIntervalFn(() => {
  selectNext()
}, UPDATE_INTERVAL)

onMounted(() => {
  if (props.value.items.length > 0) selectedItem.value = 0
})
</script>
